// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__1Ms87","button":"Image_button__3FrHW"};